import { AnyPrice, GQLPeriod, Price, TranslatedString } from "@ct-react/core";

//TYPE

export enum ArticleType {
    RENTAL = "RentalAccommodationArticle",
    SEASONAL = "SeasonalAccommodationArticle",
    ANNUAL = "AnnualAccommodationArticle",
    SALE = "SaleAccommodationArticle"
}

export enum AccommodationType {
    RENTAL = "RENTAL",
    SEASONAL ="SEASONAL",
    ANNUAL = "ANNUAL",
    SALE = "SALE"
}

// IMAGE

export type Image = {
    title?: string
    alternativeText: string | undefined
    main: boolean
    assets: [ImageAsset]
    aspectRatio: string
}

export type ImageAsset = {
    url: string //URL
    width: number
    height: number
    breakpoint: ImageBreakpoint
}

export enum ImageBreakpoint {
    SM = "SM",
    MD = "MD",
    LG = "LG",
    Original = "Original"
}

// FEATURES

export enum Orientation {
    NONE = "NONE",
    PANORAMIC = "PANORAMIC",
    NORTH = "NORTH",
    SOUTH = "SOUTH",
    EAST = "EAST",
    WEST = "WEST",
    NORTH_EAST = "NORTH_EAST",
    NORTH_WEST = "NORTH_WEST",
    SOUTH_EAST = "SOUTH_EAST",
    SOUTH_WEST = "SOUTH_WEST"
}

//PRICE

export type TouristTaxCartOption = {
    grid: [TouristTaxCartOptionGridItem]
    optionId: string
}

export type TouristTaxCartOptionGridItem = {
    ageCategory: AgeCategory
    ageRange: [number]
    price: AnyPrice
}

export enum AgeCategory {
    ADULT = "ADULT",
    CHILD = "CHILD",
    EXEMPT = "EXEMPT",
    BABY = "BABY",
    SENIOR = "SENIOR"
}

export type DiscountDefinition = {
    logic: DiscountLogic
    period: GQLPeriod
    type: DiscountType
    fixedValue: Price
    percentageValue: number
}

enum DiscountLogic {
    FIXED = "FIXED",
    PERIODED = "PERIODED"
}

enum DiscountType {
    FIXED = "FIXED",
    PERIODED = "PERIODED"
}

//

export type ObjectTypeRef = {
    id: string
    slug: string
    name: string
}

//MARKER

export type AccommodationMarker = {
    coordinates:  [ number, number ]
    id: string
    slug: string
    publishedAt: string
};

//SEO

export type SEOData = {
    title: TranslatedString
    description: TranslatedString
    image: string //URL
    keywords: [string]
    translatableKeywords: [KeyValuePairOfTranslatableSEOKeywordAndString]
}

export type KeyValuePairOfTranslatableSEOKeywordAndString = {
    key: TranslatableSEOKeyword
    value: string
}

enum TranslatableSEOKeyword {
    ARTICLE_TYPE = "ARTICLE_TYPE",
    OBJECT_TYPE = "OBJECT_TYPE"
}
